export enum DestroyOptionType {
    NO_DESTROY = 'NO_DESTROY',
    NO_MESSENGER_DESTROY = 'NO_MESSENGER_DESTROY'
}